import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import RatioContainer from 'components/consumer/RatioContainer';
import JBProductImage from 'components/essentials/JBImage/JBProductImage';
import IconPlay from 'components/icons/IconPlay';

const PDPDesktopFullScreenGallery2Thumbnail = ({
  cropData,
  enableCrops,
  isItemSelected,
  itemIndex,
  itemType,
  selectedThumbnailRef,
  setSelectedItemAndScroll,
  src,
  type,
  videoThumbnailUrl,
}) => {
  const [imageHasError, setImageHasError] = useState(false);

  if (imageHasError) {
    return null;
  }

  return (
    <RatioContainer
      wrapperClassName="h-[140px] w-[140px] [&_img]:cursor-pointer [&_img]:h-full [&_img]:object-cover [&_img]:w-full"
      ref={isItemSelected ? selectedThumbnailRef : undefined}
    >
      <button
        className={classNames(
          'border border-solid [background:none] h-full w-full focus-visible:outline-offset-[-2px]',
          {
            'border-transparent': !isItemSelected,
            'border-brand rounded-[3px] box-border [&_img]:rounded-[3px]': isItemSelected,
          }
        )}
        type="button"
        onClick={() => {
          setSelectedItemAndScroll(itemIndex);
        }}
      >
        {itemType === 'video' ? (
          <>
            {!!videoThumbnailUrl && (
              <img className="h-auto" src={videoThumbnailUrl} alt="" />
            )}
            <div className="left-[45px] pointer-events-none absolute top-[45px]">
              <IconPlay width={50} height={50} />
            </div>
          </>
        ) : (
          <JBProductImage
            ar="1:1"
            className="PDPDesktopFullScreenGallery2__gallery-image"
            cropFormat="1x1"
            crops={cropData}
            enableCrops={enableCrops}
            onError={() => {
              setImageHasError(true);
            }}
            size="10vw"
            sizes="10vw"
            src={src}
            type={type}
          />
        )}
      </button>
    </RatioContainer>
  );
};

PDPDesktopFullScreenGallery2Thumbnail.propTypes = {
  cropData: PropTypes.object,
  enableCrops: PropTypes.bool,
  isItemSelected: PropTypes.bool,
  itemIndex: PropTypes.number,
  itemType: PropTypes.string,
  selectedThumbnailRef: PropTypes.object,
  setSelectedItemAndScroll: PropTypes.func,
  src: PropTypes.string,
  type: PropTypes.string,
  videoThumbnailUrl: PropTypes.string,
};

export default PDPDesktopFullScreenGallery2Thumbnail;
